<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ارسال پیام</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.from.val" size="sm" dir="ltr" disabled />
                                    <CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
                                </CCol>
                            </CRow>
                            <br>
                            <CRow>
                                <CCol sm="3">
                                    <CTextarea v-model="form.to.val" :description="form.to.inv" label="به شماره/‌‌های" rows="3" 
                                        @keyup.enter="access=false" dir="ltr" />
                                    <small>شماره‌ها با Enter از هم جدا می‌شوند.</small>
                                    <br>
                                    <small>الگو: 989122030348</small>
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea v-model="form.msg.val" :description="form.msg.inv" label="پیام" rows="3"
                                        @keyup.enter="access=false" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary">ارسال</CButton>
                        </div>
                        <br>
                        <div v-for="(row, index) in status" :key="index">{{row}}</div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="access=false;get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.from.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.from.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: { val: this.$store.state.user_id, inv: '', v: { req: true, max: 8 } },
                from: { val: '', inv: '', v: { req: true, max: 64 } },
                to: { val: '', inv: '', v: { req: true, max: 256 } },
                msg: { val: '', inv: '', v: { req: true, max: 256 } },
            },
            number_like: '',
            disable: false,
            users: [],
            numbers: [],
            status: [],
            access: true,
            modal: false,
            from_selected: '',
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        get_users() {
            this.axios.get('users/?type=send_sms_messages')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_numbers() {
            this.axios.get('user_nums/' 
                + '?user_id=' + this.form.user_id.val
                + '&number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        if(key == 'to'){
                            data.set(key, JSON.stringify(this.form.to.val.split('\n')));
                        } else {
                            data.set(key, this.form[key].val);
                        }  
                    }
                    this.axios.post('sms_groups/', data)
                        .then(res => {
                            if(res.data.state == 'Error on AccountBalance'){
                                this.$notify({
                                    group: 'foo',
                                    type: 'error',
                                    text: 'موجودی حساب کافی نیست.'
                                });
                            } else {
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    text: 'ارسال با موفقیت انجام شد.'
                                });
                                for (const key in this.form){
                                    this.form[key].val = '';
                                }
                                if(res.data.data != null){
                                    this.status.push('گزارش ارسال');
                                    re.data.data.map(val => {
                                        this.status.push(`شماره: ${val.number} - تعرفه: ${val.sms_fee} - UUID: ${val.uuid}`);
                                    });
                                }
                                if(res.data.black_list.length > 0){
                                    this.status.push('لیست سیاه');
                                    res.data.black_list.map(val =>{
                                        this.status.push(val);
                                    })
                                }
                            } 
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_send_sms_messages == false
            && this.$store.state.perms.can_send_all_user_sms_messages == false
            && this.$store.state.perms.can_send_same_group_user_sms_messages == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>